<template>
  <span>
    <input
      type="radio"
      :key="source.name + '-input'"
      name="source"
      :value="source.name"
    />
    <label
      :for="source.name"
      :key="source.name + '-label'"
      class="source-label"
      :class="source.selected ? 'source-label-selected' : 'source-label-notSelected'"
      @click="handleSourceClick(source.name)"
    >
      <v-tooltip left :nudge-top="50" z-index="1000">
        <span slot="activator" class="source-logo-container">
          <img
            class="source-logo"
            :class="!source.showIFrameResults ? 'source-logo-open-new-tab' : ''"
            :src="source.imgUrl"
            :alt="source.name + ' logo'"
          >
          <span v-if="!source.showIFrameResults">
            <v-icon
              :class="!source.showIFrameResults ? 'source-logo-open-new-tab-icon' : ''"
            >open_in_new</v-icon>
          </span>
        </span>
        <span>{{ source.name }}</span>
      </v-tooltip>
      <span v-if="source.selected" class="source-label-selected-notch"></span>
    </label>
  </span>
</template>

<script>
import {POSSIBLE_ENGINES} from '../../../utils/search-engines'

export default {
  name: 'SourceNameComponent',
  props: ['source'],
  data () {
    return {
      possibleEngines: POSSIBLE_ENGINES
    }
  },
  methods: {
    handleSourceClick (sourceName) {
      this.possibleEngines.forEach(engine => { engine.selected = false })
      let selectedEngine = this.possibleEngines.find(engine => engine.name === sourceName)
      if (selectedEngine) { selectedEngine.selected = true }
      this.$emit('handleTargetEngineClick', sourceName)
    }
  }
}
</script>

<style lang="scss" scoped>
input {
  display: none;
}
.source-label {
  width: 65px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  &-selected {
    background: $grey-400;
    position: relative;
    &-notch {
      background: $grey-400;
      width: 38px;
      height: 140px;
      position: absolute;
      left: 0;
      z-index: -1;
    }
  }
  &-selected .source-logo {
    //box-shadow: 0 0 0 1px $warning;
  }
  &-notSelected {
    border-radius: 40px 0 0 40px;
    position: relative;
    z-index: 10;
    background: $bg-primary;
  }
}
.source-logo {
  width: 25px;
  aspect-ratio: 1;
  &-container {
    display: block;
    width: 45px;
    height: 45px;
    border-radius: 25px;
    padding: 10px;
    background: $bg-primary;
    position: relative;

    &:hover {
      background-color: $light-blue-400;
      box-shadow: 0 0 0 2px $grey-400;
      cursor: pointer;
    }
  }
  &-open-new-tab-icon {
    position: absolute;
    font-size: 11px;
    right: 3px;
    color: $blue-primary;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/ResultsContainer/SourceNameComponent.vue